var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trailing icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.83583 4.65667C10.222 4.60855 10.6108 4.58406 11 4.58333C17.4167 4.58333 20.1667 11 20.1667 11C19.7568 11.8774 19.2429 12.7022 18.6358 13.4567",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.05917 6.05917C4.23627 7.30104 2.77753 9.00658 1.83333 11C1.83333 11 4.58333 17.4167 11 17.4167C12.7563 17.4214 14.4749 16.908 15.9408 15.9408",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.05667 9.05667C8.78648 9.30843 8.56977 9.61203 8.41947 9.94936C8.26917 10.2867 8.18835 10.6508 8.18183 11.0201C8.17532 11.3893 8.24324 11.7561 8.38155 12.0985C8.51986 12.4409 8.72572 12.752 8.98686 13.0131C9.24799 13.2743 9.55905 13.4801 9.90148 13.6184C10.2439 13.7568 10.6107 13.8247 10.9799 13.8182C11.3492 13.8117 11.7133 13.7308 12.0506 13.5805C12.388 13.4302 12.6916 13.2135 12.9433 12.9433",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.83333 1.83333L20.1667 20.1667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.a52f63a8b05a344d8b777f0537e15914.svg";
export { ForwardRef as ReactComponent };